import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';


function Snag(){
    return(
        <>
        <p> SnagOnView</p>
        </>
    )
}

export default Snag